import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IRecentProfessionalApi } from './recentProfessionalsTypes';

export interface IGetRecentProfessionalsParams {
  officeId: string;
  jobId?: string;
  date?: string;
}

async function getRecentProfessionals({
  officeId,
  jobId,
  date,
}: IGetRecentProfessionalsParams): Promise<IRecentProfessionalApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IRecentProfessionalApi[]>(`/users/recent-professionals`, {
    headers: { ...headers, 'x-office': officeId ?? undefined },
    params: {
      jobId: jobId ?? undefined,
      date: date ?? undefined,
    },
  });

  return response.data;
}

export const recentProfessionalsApi = {
  getRecentProfessionals,
};
